<template>
  <div>
    <b-row
      class="m-1"
    >
      <b-col
        class="text-left"
        md="3"
        lg="3"
      >
        <copy-snippet
          snippet-id="copy-bc-case-id"
          label="BC CASE ID"
          :value="bcCaseId ? bcCaseId : 'N/A'"
        />
        <copy-snippet
          snippet-id="copy-case-id"
          label="CASE ID"
          :value="prefixCaseId ? prefixCaseId : caseId"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import CopySnippet from './CopySniippet.vue'

export default {
  components: {
    BRow,
    BCol,
    CopySnippet,
  },
  props: {
    bcCaseId: {
      type: String,
      required: true,
    },
    prefixCaseId: {
      type: [String, null],
      required: true,
    },
  },
  data() {
    return {
      caseId: this.$route.params.id,
    }
  },
}
</script>

  <style lang="scss">
  .alert-custom {
    background-color: #00A2E8 !important;
    color: white  !important;
    text-align: center !important;
  }
  </style>
